var map = {
	"./01__fire_anim.mp4": 8737,
	"./02_broom.png": 1190,
	"./02_whitch_hat.png": 3910,
	"./04_pumpkin.png": 8138,
	"./06_skeleton.png": 59,
	"./07_assemble.png": 1771,
	"./10_cauldron.png": 4243,
	"./11_devil.png": 3866,
	"./12_moon_wond_anim.mp4": 1398,
	"./14_hole.png": 6308,
	"./15_mirror_anim.mp4": 4152,
	"./16_moon.png": 1813,
	"./17_grave.png": 1158,
	"./18_corn.png": 1054,
	"./19_goat.png": 6510,
	"./20_spider.png": 3487,
	"./21_cabin.png": 2399,
	"./22_frog.png": 572,
	"./23_sword.png": 540,
	"./24_trap.png": 4833,
	"./25_death.png": 9778,
	"./26_gragouille.png": 6848,
	"./27_cat.png": 9641,
	"./28_mushroom.png": 509,
	"./29_map.png": 1890,
	"./30_ghost_anim.mp4": 112,
	"./31_candle.png": 3801,
	"./36_bat_signal.png": 4913,
	"./37_potion.png": 945,
	"./38_lantern.png": 6597,
	"./39_magical_hunt.png": 1790,
	"./40_coin_coin.png": 7649,
	"./41_dragon.png": 5344,
	"./42_misha_hot_dog.png": 1311,
	"./43_saloon.png": 8447,
	"./44_she_ra_sword.png": 9184,
	"./45_sun_eat_cloud_2.png": 3517,
	"./46_snowman.png": 9588,
	"./47_vampire.png": 6282,
	"./48_sword_surfing.png": 2567,
	"./49_toothless.png": 2241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3946;